import React from 'react';
import styles from './flyout.scss';
import FlyoutItem from './FlyoutItem';

const columns = [
  ['Bedding', 'Curtains', 'Blinds'],
  ['Bathroom Accessories', 'Home Decoration'],
  ['Cooking'],
  ['Dining'],
  ['Storage, Laundry & Cleaning'],
  ['Garden', 'DIY, Paint & Wallpaper'],
];

const Flyout = ({
  visible,
  title = '',
  items = [],
  fetchAndStoreChildCategories,
  navigationV2Active,
  scrollToTop,
  childHierarchy,
  setOpened,
}) => {
  const groupedItems = columns.map(column =>
    column
      .map(columnName => items.find(item => item.title === columnName))
      .filter(item => !!item)
  );

  return (
    <div className={styles.flyoutContainer}>
      {groupedItems.map((columnItem, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ul key={`column-${index}`} className={styles.flyoutItems}>
          {columnItem.map(item => (
            <FlyoutItem
              {...item}
              className={styles.flyoutItem}
              key={item.id}
              depth={1}
              categoryId={item.id}
              hierarchy={childHierarchy}
              backLabel={title}
              toggleParentOpened={setOpened}
              fetchAndStoreChildCategories={fetchAndStoreChildCategories}
              parentOpen={visible}
              openClass={styles.opened}
              navigationV2Active={navigationV2Active}
              scrollToTop={scrollToTop}
            />
          ))}
        </ul>
      ))}
    </div>
  );
};
export default Flyout;
